import React, { Fragment } from "react";
import "../../../styles/reset.desktop.css";
import "../../../styles/slick.css";
import "../../../styles/slick-theme.css";
import "../../../styles/slick-reset-desktop.css";
import "@cars24/turbo-web/lib/index.css";

export default function withCommonLayout(WrappedComponent) {

    const Layout = (props) => {
        return (
            <Fragment>
                <WrappedComponent {...props} />
            </Fragment>
        );
    };
    return Layout;
}
